import { render } from "./EmptyLayout.vue?vue&type=template&id=638e5896"
import script from "./EmptyLayout.vue?vue&type=script&lang=js"
export * from "./EmptyLayout.vue?vue&type=script&lang=js"

import "./EmptyLayout.vue?vue&type=style&index=0&id=638e5896&lang=css"

import exportComponent from "../../../../../../../../../worktrees/adel01/tcd-userpage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__